import { contentType } from "./types";

const ROTATE: contentType = {
    title: 'Image Rotator',
    subtitle: 'Rotate Image Online for Free! No registration!',
}

const RESIZE: contentType = {
    title: 'Free image resizer',
    subtitle: 'Resize any image online in 3 clicks',
}

const FLIP: contentType = {
    title: 'Flip Image Online',
    subtitle: 'Flip Image Online for Free! Quickly & Easily!',
}

const CROPPER: contentType = {
    title: 'Crop Image Online',
    subtitle: 'Crop any image free with Online Image Cropper.',
}


export default function getContantPage(service: string): contentType {
    switch (service) {
        case 'rotator':
            return ROTATE;
        case 'resizer':
            return RESIZE;
        case 'flipper':
            return FLIP;
        case 'cropper':
            return CROPPER;
        default:
            return RESIZE;
    }

}